export default __webpack_public_path__ + "static/media/itu-inside.4f2403a2.jpg";